/**
 * Конфигурация уведомлений для WebSocket-событий DATA_UPDATED/DATA_CREATED/DATA_DELETED.
 *
 * При добавлении нового этапа/таблицы — добавляй запись сюда,
 * не трогая WebSocketProvider.
 */

export interface WsEntityConfig {
  name: string;
  path: string;
  label: string;
}

/**
 * Маппинг entityType → конфигурация уведомления.
 * Ключи соответствуют полю `entityType` в DataUpdatedPayload.
 */
export const WS_ENTITY_TYPE_CONFIG: Record<string, WsEntityConfig> = {
  references:            { name: 'Справочники',              path: '/references', label: 'Перейти к справочникам' },
  keyAssortment:         { name: 'Ключевой ассортимент',     path: '/references', label: 'Перейти к ключевому ассортименту' },
  priceGram:             { name: 'Планирование цен',         path: '/references', label: 'Перейти к планированию цен' },
  'sales-plan':          { name: 'План продаж',              path: '/sales',      label: 'Перейти к плану продаж' },
  salesPlan:             { name: 'План продаж',              path: '/sales',      label: 'Перейти к плану продаж' },
  'business-group-stats':{ name: 'Статистика бизнес-групп', path: '/sales',      label: 'Перейти к плану продаж' },
  purchasePlan:          { name: 'План закупок',             path: '/purchase',   label: 'Перейти к плану закупок' },
  shipmentPercentage:    { name: 'Процент отгрузки',         path: '/references', label: 'Перейти к проценту отгрузки' },
  pricePlanning:         { name: 'Планирование цен',         path: '/references', label: 'Перейти к планированию цен' },
};

/**
 * Маппинг tableId → человекочитаемое название таблицы.
 * Приоритет выше, чем WS_ENTITY_TYPE_CONFIG.name.
 */
export const WS_TABLE_ID_NAMES: Record<string, string> = {
  'key-assortment-main':      'Ключевой ассортимент',
  'shipment-percentage':       'Процент отгрузки',
  'price-planning-pack':       'Планирование цен (Упаковки)',
  'price-planning-gram':       'Планирование цен (Граммы)',
  'suppliers-knp-main':        'Поставщики с КНП',
  'stage1-cpr':                'План продаж по ЦПР',
  'stage1-planning':           'План продаж',
  'stage1-kn':                 'План продаж КН',
  'stage2-periods-table':      'Периоды закупок',
  'stage2-tn-v2':              'План закупок ТН-ЦПР',
  'stage2-analytics-table':    'Аналитика ТН-ЦПР',
  'purchase-stage2-2s8m':      'План закупок по периодам',
  'stage4-revenue':            'Распределение выручки',
  'stage4-knr':                'Распределение КНР',
  'stage5-manager-sales-table':'План продаж менеджера',
};
